import { GET_END_USER, GET_UNIQUE_END_USER, UPDATE_END_USER, GET_NECT_CUSTOMERS, GET_ESIM_CUSTOMERS, GET_EPIN_PRINT, GET_US_RETAILER_CUSTOMERS } from 'redux/constants';

const initialState = {
  endUserReport: [],
  uniqueEndUserReport: [],
  nectCustomers: [],
  eSIMCustomer: [],
  esimprint:{},
  usRetailerCustomer: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_END_USER: {
      return {
        ...state,
        endUserReport: payload,
      };
    }
    case GET_UNIQUE_END_USER: {
      return {
        ...state,
        uniqueEndUserReport: payload,
      };
    }
    case UPDATE_END_USER: {
      return {
        ...state, 
        endUserReport:
         state.endUserReport.map(item => item.customer_id === payload.customer_id ? 
          { ...item, ...payload} : item 
        )
      }
    }
    case GET_NECT_CUSTOMERS: {
      return {
        ...state,
        nectCustomers: payload,
      };
    }
    case GET_ESIM_CUSTOMERS: {
      return {
        ...state,
        eSIMCustomer: payload,
      };
    }
    case GET_EPIN_PRINT: {
      return {
        ...state,
        esimprint: payload,
      };
    }
      case GET_US_RETAILER_CUSTOMERS: {
      return {
        ...state,
        usRetailerCustomer: payload,
      };
    }
    
    default:
      return state;
  }
};
export default reducer;